export default __webpack_public_path__ + "static/media/sale_bg.dcc9bdba.gif";